const appContentRoutes = [{
  path: "/AppContent",
  name: "AppContent",
  redirect: "/AppContent/Specials",
  component: require("@/components/AppContent/AppContent").default,
  children: [{
      name: "Specials",
      path: "Specials",
      component: require("@/components/AppContent/Specials/Specials").default
    },
    {
      name: "EditSpecial",
      path: "Specials/Edit",
      component: require("@/components/AppContent/Specials/EditSpecial").default
    },
    {
      name: "Notifications",
      path: "Notifications",
      component: require("@/components/AppContent/Notifications/Notifications").default
    },
    {
      name: "EditNotification",
      path: "Notifications/Edit",
      component: require("@/components/AppContent/Notifications/EditNotification").default
    },
    {
      name: "Gallery",
      path: "Gallery",
      component: require("@/components/AppContent/Gallery/Gallery").default
    },
    {
      name: "Information",
      path: "Information",
      component: require("@/components/AppContent/Information/Information").default
    },
    {
      name: "Instructors",
      path: "Instructors",
      component: require("@/components/AppContent/Instructors/Instructors").default,
    },
    {
      name: "EditInstructor",
      path: "Instructors/Edit",
      component: require("@/components/AppContent/Instructors/EditInstructor").default
    },
    {
      name: "Schedule",
      path: "Schedule",
      component: require("@/components/AppContent/Schedule/Schedule").default
    },
    {
      name: "UpcomingEvents",
      path: "UpcomingEvents",
      component: require("@/components/AppContent/UpcomingEvents/UpcomingEvents").default
    }
  ]
}];

export default appContentRoutes;